import { mutatorAction } from 'satcheljs';
import getCalendarConfiguration from '../utils/getCalendarConfiguration';
import MailboxCalendarConfiguration from 'owa-service/lib/contract/MailboxCalendarConfiguration';
const assign = require('object-assign');

export default mutatorAction(
    'updateCalendarMailboxConfiguration',
    function updateCalendarMailboxConfiguration(
        calendarConfiguration: MailboxCalendarConfiguration
    ) {
        assign(getCalendarConfiguration(), calendarConfiguration);
    }
);
